import { useSearch } from "wouter";
import { CheckCircle2, ArrowLeft, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const searchString = useSearch();
  const params = new URLSearchParams(searchString);

  const amount = params.get("amount");
  const maskedAccount = params.get("maskedAccount");
  const cardType = params.get("cardType");
  const authCode = params.get("authCode");
  const invoiceNumber = params.get("invoiceNumber");
  const uniqueId = params.get("uniqueId");
  const name = params.get("name");

  return (
    <div className="min-h-screen bg-[#0a0f1a] flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-emerald-500/10 flex items-center justify-center">
            <CheckCircle2 className="w-12 h-12 text-emerald-400" />
          </div>
        </div>

        {/* Main Content */}
        <div className="bg-[#111827] border border-gray-800 rounded-xl p-8 text-center">
          <h1 className="text-2xl font-bold text-white mb-2">Payment Successful</h1>
          <p className="text-gray-400 mb-6">
            Your payment has been processed successfully.
          </p>

          {/* Payment Details */}
          {amount && (
            <div className="bg-[#0a0f1a] rounded-lg p-6 mb-6 text-left space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-gray-400 text-sm">Amount Paid</span>
                <span className="text-white text-xl font-bold">${parseFloat(amount).toFixed(2)}</span>
              </div>
              {name && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-400 text-sm">Name</span>
                  <span className="text-gray-200 text-sm">{name}</span>
                </div>
              )}
              {cardType && maskedAccount && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-400 text-sm">Card</span>
                  <span className="text-gray-200 text-sm">{cardType} {maskedAccount}</span>
                </div>
              )}
              {authCode && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-400 text-sm">Auth Code</span>
                  <span className="text-gray-200 text-sm font-mono">{authCode}</span>
                </div>
              )}
              {invoiceNumber && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-400 text-sm">Reference</span>
                  <span className="text-gray-200 text-xs font-mono">{invoiceNumber}</span>
                </div>
              )}
              {uniqueId && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-400 text-sm">Transaction ID</span>
                  <span className="text-gray-200 text-sm font-mono">{uniqueId}</span>
                </div>
              )}
            </div>
          )}

          <p className="text-gray-500 text-sm mb-6">
            A confirmation will be sent to your email address on file.
            Please save your reference number for your records.
          </p>

          {/* Contact Info */}
          <div className="border-t border-gray-800 pt-6 space-y-3">
            <p className="text-gray-400 text-sm">Need help? Contact us:</p>
            <div className="flex justify-center gap-6">
              <a href="tel:+17029131109" className="flex items-center gap-2 text-blue-400 hover:text-blue-300 text-sm">
                <Phone className="w-4 h-4" />
                (702) 913-1109
              </a>
              <a href="mailto:support@unifipro.ai" className="flex items-center gap-2 text-blue-400 hover:text-blue-300 text-sm">
                <Mail className="w-4 h-4" />
                Email Support
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-gray-600 text-xs mt-6">
          Powered by UnifiPro AI &bull; Secure Payment Processing
        </p>
      </div>
    </div>
  );
}
